import { useMemo } from 'react';
import { Authorize, GlobalButton, NavigateLinks } from '@/components';
import { BUSINESS_ROLE_GROUPS } from '@/components/security/AppRoles';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { Add as AddIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import SearchBar from './components/SearchBar';
import LogisticOperatorsTable from './components/LogisticOperatorsTable';
import { useLogisticOperatorsFilter } from './hooks/useLogisticOperatorsFilter';

const LogisticOperator = () => {
  const navigate = useNavigate();
  const breadcrumbs = useMemo(
    () => [
      { label: 'Inicio', to: '/' },
      { label: 'Sistema de envíos', to: '/business' },
      { label: 'Red logística', to: '/business/logistics-network' },
    ],
    []
  );
  const { filters, setFilters, initialFilter } = useLogisticOperatorsFilter();

  return (
    <section className='flex flex-col gap-6 w-full h-full'>
      <NavigateLinks
        actualPage='Operadores Logísticos'
        breadcrumbs={breadcrumbs}
      />
      <Authorize permission={BUSINESS_ROLE_GROUPS.management}>
        <div className='flex gap-2.5 justify-end'>
          <GlobalButton
            variant={GlobalButtonVariant.primaryButton}
            action={() => navigate('new')}
          >
            <AddIcon />
            Nuevo Operador
          </GlobalButton>
        </div>
      </Authorize>
      <SearchBar
        initialFilter={initialFilter}
        filter={filters}
        search={setFilters}
      />
      <LogisticOperatorsTable filter={filters} />
    </section>
  );
};

export default LogisticOperator;
